import React, { FC } from 'react'
import { Col } from 'antd'
import { ColProps } from 'antd/es/col'

export const Column: FC<ColProps> = ({ children, sm, lg, ...props }) => (
  <Col {...props} sm={sm || { span: 24 }} lg={lg || { span: 12 }}>
    {children}
  </Col>
)
